export default {
    methods: {
        asyncImportCom(key, val) {
            const s = key.split('.')
            let p = s.shift()
            let t = this
            while (p != null) {
                t = t[p]
                p = s.shift()
            }
            if (!t.inited) {
                t.inited = true
            }
            t.visible = val == null ? !t.visible : val
        }
    }
}
